var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.options,"label":_vm.i18n(_vm.label),"outlined":_vm.outlined,"readonly":_vm.readonly,"clearable":_vm.clearable,"prepend-inner-icon":_vm.icon,"hide-details":_vm.hideDetails},model:{value:(_vm.review),callback:function ($$v) {_vm.review=$$v},expression:"review"}})
}
var staticRenderFns = []

export { render, staticRenderFns }